import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Card,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@e2n/ui';
import { ArbeitsBereichBadge } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/ArbeitsBereichBadge';
import { SchichttauschAntrag } from '@/domain/navigation/benachrichtigungen/types/SchichttauschAntrag';
import { faArrowRightArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line max-lines-per-function
export function InfoBox({ antrag }: { antrag: SchichttauschAntrag }) {
  const { t } = useTranslation();
  return (
    <Card className="p-4 pr-6">
      <div className="flex flex-row gap-2 items-start justify-center">
        <FontAwesomeIcon
          icon={faArrowRightArrowLeft}
          className="text-primary-blue-600 p-2"
        />
        <div className="flex flex-col gap-3 w-full py-2">
          <div className="flex flex-row gap-2 justify-between items-center">
            <span className="text-neutrals-900 text-sm font-semibold">
              {t(
                'domain.navigation.benachrichtigungen.schichttauschAntraege.dialog.infobox.title',
                {
                  name: `${antrag.mitarbeiter.vorname} ${antrag.mitarbeiter.nachname}`,
                },
              )}
            </span>
            <span className="text-neutrals-700 text-xs">
              {dayjs(antrag.erstellungsDatum)
                .locale('de')
                .format('ddd, DD. MMMM, HH:mm')}
              {' Uhr'}
            </span>
          </div>
          <div className="flex flex-row gap-2 items-center">
            <Popover>
              <PopoverTrigger asChild>
                <Avatar className="size-8">
                  <AvatarImage src={antrag.mitarbeiter.bildUrl} />
                  <AvatarFallback>{`${antrag.mitarbeiter.vorname
                    .substring(0, 1)
                    .toUpperCase()}${antrag.mitarbeiter.nachname
                    .substring(0, 1)
                    .toUpperCase()}`}</AvatarFallback>
                </Avatar>
              </PopoverTrigger>
              <PopoverContent
                className="w-72 bg-neutrals-100"
                side="bottom"
                align="start">
                <div className="flex flex-col gap-2">
                  <span className="text-sm font-semibold">{`${antrag.mitarbeiter.vorname} ${antrag.mitarbeiter.nachname}`}</span>
                  <div className="flex items-start justify-between">
                    <div className="flex flex-col gap-2 text-neutrals-900 text-sm font-normal">
                      {antrag.mitarbeiter.arbeitnehmertyp && (
                        <span>
                          {t(
                            'domain.navigation.benachrichtigungen.schichttauschAntraege.dialog.infobox.arbeitnehmerTyp.label',
                          )}
                        </span>
                      )}

                      {antrag.mitarbeiter.arbeitsbereich && (
                        <span>
                          {' '}
                          {t(
                            'domain.navigation.benachrichtigungen.schichttauschAntraege.dialog.infobox.arbeitsbereich',
                          )}
                        </span>
                      )}
                    </div>
                    <div className="flex flex-col items-end gap-2 text-neutrals-900 text-sm font-semibold">
                      {antrag.mitarbeiter.arbeitnehmertyp && (
                        <span>
                          {t(
                            `domain.navigation.benachrichtigungen.schichttauschAntraege.dialog.infobox.arbeitnehmerTyp.options.${antrag.mitarbeiter.arbeitnehmertyp}`,
                          )}
                        </span>
                      )}
                      {antrag.mitarbeiter.arbeitsbereich && (
                        <ArbeitsBereichBadge
                          arbeitsbereich={antrag.mitarbeiter.arbeitsbereich}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
            <span className="text-neutrals-700 text-sm">
              {antrag.bemerkungAntragsteller}
            </span>
          </div>
        </div>
      </div>
    </Card>
  );
}
